/* tslint:disable */
/* eslint-disable */
/**
 * Swagger LogisticProcess - OpenAPI 3.0
 * Planning of the collaborator
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface PeriodResponse {
    'hourIn'?: string;
    'hourOut'?: string;
    'id'?: number;
}
export interface PlanningGlobalResponse {
    'message'?: string;
    'code'?: string;
}
export interface PlanningHoursResponse {
    'hours'?: number;
    'hourIn'?: string;
    'hourOut'?: string;
}
export interface PlanningRefreshRequest {
    'date'?: string;
}
export interface PlanningRefreshResponse {
    'message'?: string;
    'code'?: string;
}
export interface PlanningRequest {
    'date'?: string;
    'collaboratorId'?: number;
    'periods'?: Array<PeriodResponse>;
}
export interface PlanningResponse {
    'collaboratorId'?: number;
    'durationTime'?: number;
    'dateDay'?: string;
    'periods'?: Array<PeriodResponse>;
}
export interface PlanningsSiteResponse {
    'message'?: string;
    'code'?: string;
}

/**
 * PlanningsApi - axios parameter creator
 */
export const PlanningsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * create manually planning of a external collaborator
         * @summary create manually planning of a external collaborator
         * @param {PlanningRequest} [planningRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (planningRequest?: PlanningRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/planning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(planningRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get planning by collaborator
         * @summary Get Planning of the collaborator
         * @param {number} collaboratorId collaborator id
         * @param {string} from date from
         * @param {string} to date to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeriodsPlanning: async (collaboratorId: number, from: string, to: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collaboratorId' is not null or undefined
            assertParamExists('getPeriodsPlanning', 'collaboratorId', collaboratorId)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getPeriodsPlanning', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getPeriodsPlanning', 'to', to)
            const localVarPath = `/v1/planning/collaborator/planning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (collaboratorId !== undefined) {
                localVarQueryParameter['collaborator_id'] = collaboratorId;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get planning by site_code
         * @summary Get Planning of the collaborator
         * @param {string} siteCode Code of the site
         * @param {string} date date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanningProviderGlobalBySiteCode: async (siteCode: string, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'siteCode' is not null or undefined
            assertParamExists('getPlanningProviderGlobalBySiteCode', 'siteCode', siteCode)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getPlanningProviderGlobalBySiteCode', 'date', date)
            const localVarPath = `/v1/planning/global/{site_code}`
                .replace(`{${"site_code"}}`, encodeURIComponent(String(siteCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get planning by collaborator
         * @summary Get Planning of the collaborator
         * @param {number} collaboratorId unique identificator from collaborator
         * @param {string} date date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanningProviderHours: async (collaboratorId: number, date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collaboratorId' is not null or undefined
            assertParamExists('getPlanningProviderHours', 'collaboratorId', collaboratorId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getPlanningProviderHours', 'date', date)
            const localVarPath = `/v1/planning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (collaboratorId !== undefined) {
                localVarQueryParameter['collaborator_id'] = collaboratorId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refresh planning by collaborator
         * @summary Refresh planning of the collaborator
         * @param {number} id unique identificator from collaborator
         * @param {PlanningRefreshRequest} planningRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshPlanningProviderHours: async (id: number, planningRefreshRequest: PlanningRefreshRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refreshPlanningProviderHours', 'id', id)
            // verify required parameter 'planningRefreshRequest' is not null or undefined
            assertParamExists('refreshPlanningProviderHours', 'planningRefreshRequest', planningRefreshRequest)
            const localVarPath = `/v1/planning/collaborator/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(planningRefreshRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update manually planning of a external collaborator
         * @summary update manually planning of a external collaborator
         * @param {PlanningRequest} [planningRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (planningRequest?: PlanningRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/planning`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(planningRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanningsApi - functional programming interface
 */
export const PlanningsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanningsApiAxiosParamCreator(configuration)
    return {
        /**
         * create manually planning of a external collaborator
         * @summary create manually planning of a external collaborator
         * @param {PlanningRequest} [planningRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(planningRequest?: PlanningRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(planningRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningsApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get planning by collaborator
         * @summary Get Planning of the collaborator
         * @param {number} collaboratorId collaborator id
         * @param {string} from date from
         * @param {string} to date to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPeriodsPlanning(collaboratorId: number, from: string, to: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanningResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPeriodsPlanning(collaboratorId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningsApi.getPeriodsPlanning']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get planning by site_code
         * @summary Get Planning of the collaborator
         * @param {string} siteCode Code of the site
         * @param {string} date date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanningProviderGlobalBySiteCode(siteCode: string, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanningGlobalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanningProviderGlobalBySiteCode(siteCode, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningsApi.getPlanningProviderGlobalBySiteCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get planning by collaborator
         * @summary Get Planning of the collaborator
         * @param {number} collaboratorId unique identificator from collaborator
         * @param {string} date date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPlanningProviderHours(collaboratorId: number, date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanningHoursResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPlanningProviderHours(collaboratorId, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningsApi.getPlanningProviderHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refresh planning by collaborator
         * @summary Refresh planning of the collaborator
         * @param {number} id unique identificator from collaborator
         * @param {PlanningRefreshRequest} planningRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshPlanningProviderHours(id: number, planningRefreshRequest: PlanningRefreshRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanningRefreshResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshPlanningProviderHours(id, planningRefreshRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningsApi.refreshPlanningProviderHours']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * update manually planning of a external collaborator
         * @summary update manually planning of a external collaborator
         * @param {PlanningRequest} [planningRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(planningRequest?: PlanningRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(planningRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanningsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanningsApi - factory interface
 */
export const PlanningsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanningsApiFp(configuration)
    return {
        /**
         * create manually planning of a external collaborator
         * @summary create manually planning of a external collaborator
         * @param {PlanningRequest} [planningRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(planningRequest?: PlanningRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.create(planningRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get planning by collaborator
         * @summary Get Planning of the collaborator
         * @param {number} collaboratorId collaborator id
         * @param {string} from date from
         * @param {string} to date to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPeriodsPlanning(collaboratorId: number, from: string, to: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlanningResponse>> {
            return localVarFp.getPeriodsPlanning(collaboratorId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Get planning by site_code
         * @summary Get Planning of the collaborator
         * @param {string} siteCode Code of the site
         * @param {string} date date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanningProviderGlobalBySiteCode(siteCode: string, date: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanningGlobalResponse> {
            return localVarFp.getPlanningProviderGlobalBySiteCode(siteCode, date, options).then((request) => request(axios, basePath));
        },
        /**
         * Get planning by collaborator
         * @summary Get Planning of the collaborator
         * @param {number} collaboratorId unique identificator from collaborator
         * @param {string} date date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlanningProviderHours(collaboratorId: number, date: string, options?: RawAxiosRequestConfig): AxiosPromise<PlanningHoursResponse> {
            return localVarFp.getPlanningProviderHours(collaboratorId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * Refresh planning by collaborator
         * @summary Refresh planning of the collaborator
         * @param {number} id unique identificator from collaborator
         * @param {PlanningRefreshRequest} planningRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshPlanningProviderHours(id: number, planningRefreshRequest: PlanningRefreshRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlanningRefreshResponse> {
            return localVarFp.refreshPlanningProviderHours(id, planningRefreshRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * update manually planning of a external collaborator
         * @summary update manually planning of a external collaborator
         * @param {PlanningRequest} [planningRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(planningRequest?: PlanningRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.update(planningRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanningsApi - object-oriented interface
 */
export class PlanningsApi extends BaseAPI {
    /**
     * create manually planning of a external collaborator
     * @summary create manually planning of a external collaborator
     * @param {PlanningRequest} [planningRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public create(planningRequest?: PlanningRequest, options?: RawAxiosRequestConfig) {
        return PlanningsApiFp(this.configuration).create(planningRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get planning by collaborator
     * @summary Get Planning of the collaborator
     * @param {number} collaboratorId collaborator id
     * @param {string} from date from
     * @param {string} to date to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPeriodsPlanning(collaboratorId: number, from: string, to: string, options?: RawAxiosRequestConfig) {
        return PlanningsApiFp(this.configuration).getPeriodsPlanning(collaboratorId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get planning by site_code
     * @summary Get Planning of the collaborator
     * @param {string} siteCode Code of the site
     * @param {string} date date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlanningProviderGlobalBySiteCode(siteCode: string, date: string, options?: RawAxiosRequestConfig) {
        return PlanningsApiFp(this.configuration).getPlanningProviderGlobalBySiteCode(siteCode, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get planning by collaborator
     * @summary Get Planning of the collaborator
     * @param {number} collaboratorId unique identificator from collaborator
     * @param {string} date date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPlanningProviderHours(collaboratorId: number, date: string, options?: RawAxiosRequestConfig) {
        return PlanningsApiFp(this.configuration).getPlanningProviderHours(collaboratorId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refresh planning by collaborator
     * @summary Refresh planning of the collaborator
     * @param {number} id unique identificator from collaborator
     * @param {PlanningRefreshRequest} planningRefreshRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public refreshPlanningProviderHours(id: number, planningRefreshRequest: PlanningRefreshRequest, options?: RawAxiosRequestConfig) {
        return PlanningsApiFp(this.configuration).refreshPlanningProviderHours(id, planningRefreshRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update manually planning of a external collaborator
     * @summary update manually planning of a external collaborator
     * @param {PlanningRequest} [planningRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public update(planningRequest?: PlanningRequest, options?: RawAxiosRequestConfig) {
        return PlanningsApiFp(this.configuration).update(planningRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



